import { CloudUpload } from 'lucide-react';

import { OPTIONAL_TEXT } from '#/utils/constants';

function CustomInput({
  label,
  type = 'text',
  className = '',
  onChange,
  placeholder,
  isError,
  errorMessage,
  isRequired = true,
  optionalLabelText = OPTIONAL_TEXT,
  ...props
}) {
  const isFileType = type === 'file';
  const finalPlaceholder = `${placeholder}${isRequired ? '*' : ` (${optionalLabelText})`}`;

  return (
    <div className="custom-input">
      {label && <label>{label}</label>}
      <div className={isFileType ? 'file-input' : ''}>
        <input
          type={type}
          onChange={onChange}
          placeholder={finalPlaceholder}
          className={`form-control ${className} ${isError ? 'error-input' : ''}`}
          {...props}
        />
        {isFileType && (
          <div className="file-input-text">
            <CloudUpload />
            <span>{finalPlaceholder}</span>
          </div>
        )}
      </div>
      {isError && errorMessage && <p>{errorMessage}</p>}
    </div>
  );
}

export default CustomInput;
